import { productHasGiftTag } from '../productGiftTags';

/**
 * Products for an admin-configured homepage shelf.
 * @param {Record<string, object[]>} productsByCategory
 * @param {{ category_slug: string, tag_filter?: string, limit?: number }} shelf
 */
export function resolveHomeShelfProducts(productsByCategory, shelf) {
  const slug = String(shelf?.category_slug || '').trim();
  if (!slug) return [];
  const list = productsByCategory[slug] || [];
  const tag = String(shelf?.tag_filter || '').trim();
  let rows = list.filter((p) => p && p.is_visible !== false);
  if (tag) {
    rows = rows.filter((p) => productHasGiftTag(p, tag));
  }
  const limit = Math.min(12, Math.max(4, Number(shelf?.limit) || 8));
  return rows.slice(0, limit).map((p) => ({ ...p, category: slug }));
}
